import React from 'react';
import Icon from '../primitives/Icon';
import './chat.css';

const KIND = {
  dataset: { icon: 'file-spreadsheet', label: 'Dataset' },
  model: { icon: 'brain', label: 'Model' },
  prediction: { icon: 'chart-line', label: 'Predictions' },
};

// "Customer_master.xlsx" → "XLSX"; names without an extension fall back to the kind label.
const fileMeta = (name, kind) => {
  const label = (KIND[kind] || KIND.dataset).label;
  const dot = typeof name === 'string' ? name.lastIndexOf('.') : -1;
  const ext = dot > 0 ? name.slice(dot + 1).toUpperCase() : '';
  return ext && ext.length <= 5 ? `${ext} · ${label}` : label;
};

const AttachmentCard = ({ name, kind = 'dataset' }) => (
  <div className={`q-file q-file--${KIND[kind] ? kind : 'dataset'}`} title={name}>
    <span className="q-file__icon">
      <Icon name={(KIND[kind] || KIND.dataset).icon} size={16} />
    </span>
    <span className="q-file__text">
      <span className="q-file__name">{name}</span>
      <span className="q-file__meta">{fileMeta(name, kind)}</span>
    </span>
  </div>
);

const UserMessage = ({ text, attached }) => (
  <div className="q-fade-in q-user">
    <div className="q-user__stack">
      {attached && attached.length > 0 && (
        <div className="q-attach-row q-attach-row--end">
          {attached.map(a => <AttachmentCard key={a.id} name={a.name} kind={a.kind} />)}
        </div>
      )}
      {text && <div className="q-user__bubble">{text}</div>}
    </div>
  </div>
);

export default UserMessage;
